import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Warning = styled('div')`
  font-size: 16px;
`

export const Field = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Label = styled('span')`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${colors.gray300};
`

export const ValueRow = styled('div')`
  display: flex;
  gap: 8px;
  align-items: stretch;
`

export const Value = styled('code')`
  flex: 1;
  padding: 10px 12px;
  border: 1px solid ${colors.gray300};
  border-radius: 3px;
  font-family: 'SFMono-Regular', Consolas, Menlo, monospace;
  font-size: 13px;
  word-break: break-all;
  background: ${colors.gray200};
`

export const CopyIconButton = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  border: 1px solid ${colors.gray300};
  border-radius: 3px;
  background: ${colors.white100};
  color: ${colors.blue500};
  cursor: pointer;

  &:hover {
    background: ${colors.gray200};
  }

  svg {
    font-size: 18px;
  }
`

export const Actions = styled('div')`
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid ${colors.gray200};
`
